import { render } from "./compare-responses-table.vue?vue&type=template&id=76c9878d&scoped=true&ts=true"
import script from "./compare-responses-table.vue?vue&type=script&lang=ts"
export * from "./compare-responses-table.vue?vue&type=script&lang=ts"

import "./compare-responses-table.vue?vue&type=style&index=0&id=76c9878d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c9878d"]])

export default __exports__